import axios from 'axios'
import { Message } from 'element-ui'
import { BASEURL } from '@/api/config';
// 添加请求拦截器
const instance = axios.create({
    baseURL: BASEURL,
    timeout: 1000 * 60 * 10,
})

// 设置全局默认headers
instance.defaults.headers.common['Content-Type'] = 'application/json'
instance.defaults.headers.common['Accept'] = 'application/json'

// 请求拦截器 - 动态添加token和creditCode
instance.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token
            config.headers['creditCode'] = localStorage.getItem('creditCode')
            config.headers['merchantId'] = localStorage.getItem('merchantId')
        }
        return config
    },
    err => {
        Message({
            message: err.message || '服务器错误',
            type: 'error',
            duration: 5000
        })
        return Promise.reject(err)
    }
)
instance.interceptors.response.use(
    function(response) {
        const res = response

        return Promise.resolve(res)
    },
    function(error) {
        // 如果是取消请求，不显示错误提示
        if (axios.isCancel(error)) {
            return Promise.reject(error);
        }
        console.log('error:', error)
        Message({
            message: error.msg || '服务器错误',
            type: 'error',
            duration: 5000
        })
        return Promise.reject(error);
    }
);

// 请求处理
export default instance


// WEBPACK FOOTER //
// ./src/utils/http.js